export default __webpack_public_path__ + "static/media/left-hex-d48d36dc91fa96f7e3ba6116e44feace.png";